<template>
    <div>
        <breadcrumbs v-if="!isMobile" :page="$t('shopping_cart.shopping_cart_title')"/>
        <div class="cart-wrap">
            <div class="container">
                <mobile-cart v-if="isMobile"/>
                <cart v-else/>
                <div v-if="cart" class="cart-footer">
                    <!--<div :class="['cart-footer-terms-and-conditions', {'-red': !confirm}]">
                        <b-form-checkbox v-model="confirm" @change="handleConfirm($event)">
                            {{ $t('tc_prefix') }}
                            <a href="#" @click.prevent="showTermsAndConditionsModal">
                                {{ $t('terms_and_conditions') }}
                            </a>
                            {{ $t('tc_glue') }}
                            <a href="#" @click.prevent="showPrivacyPolicyModal">
                                {{ $t('privacy_policy') }}
                            </a>
                            {{ $t('tc_suffix') }}
                        </b-form-checkbox>
                    </div>-->
                    <div :class="{'text-right': !isMobile}">
                        <div class="cart-footer-total">
                            <div>
                                {{ $t('shopping_cart.total', {amount: $options.filters.currency(total)}) }}
                            </div>
                            <small v-if="true">{{ $t('shopping_cart.include_vat', {amount: $options.filters.currency(vat)}) }}</small>
                        </div>
                        <div class="cart-footer-checkout-btn">
                            <a href="#" @click.prevent="goToCheckout()"
                                         :class="['btn', 'btn-icon-right', 'text-uppercase', 'btn-shadow', 'btn-success']">
                                <!--`btn-${confirm ? 'success' : 'light'}`, {disabled: !confirm}]-->
                                <template>
                                    {{ $t('checkout') }}
                                </template>
                                <span v-if="!isMobile" class="material-icon icon-add_shopping_cart"/>
                                <span v-else class="material-icon icon-keyboard_arrow_right"/>
                            </a>
                        </div>
                    </div>
                </div>
                <powered-by v-if="cart && hasPoweredBy"/>
            </div>
            <vue-headful :title="headTitle($t('shopping_cart.shopping_cart_title'))"/>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../scss/variables";

    .cart-wrap {
        padding: 60px 0 120px;

        > .container {
            position: relative;
            padding-bottom: 50px;
        }
    }

    .cart-footer {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 110px;
        padding: 0 60px;
        left: 0;
        bottom: 0;
        z-index: 2;
        background-color: var(--bg-secondary-color);

        > div {
            display: flex;
            width: 100%;
            flex-grow: 1;

            &:last-child {
                align-items: center;
                justify-content: flex-end;
            }
        }

        &-terms-and-conditions {
            display: flex;
            flex-direction: column;
            justify-content: center;
            max-width: 600px;
            height: 100%;
            padding: 0 50px;

            a {
                color: inherit;
                text-decoration: underline;

                &:hover {
                    text-decoration: none;
                }
            }

            &.-red {
                position: relative;

                &::before {
                    position: absolute;
                    content: '';
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    opacity: .15;
                    background-color: var(--danger-color);
                    z-index: 0;
                }

                > * {
                    position: relative;
                    z-index: 1;
                }

                &,
                a {
                    color: var(--danger-color);
                }
            }
        }

        &-total {
            font-size: 1.5rem;
            line-height: 1;
            color: var(--text-color);

            small {
                font-size: .87rem;
                color: var(--text-secondary-color);
            }
        }

        &-checkout-btn {
            margin-left: 55px;
        }
    }

    body.-is-mobile {

        #wrapper {

            > main {
                background-color: var(--bg-secondary-color);
            }
        }

        .cart-wrap {
            padding: 120px 0 190px;
        }

        .cart-footer {
            height: 80px;
            padding-left: 20px;
            padding-right: 20px;
            background-color: var(--bg-color);

            &-total {
                margin-right: auto;
                font-size: 1.25rem;
                overflow: hidden;
                text-align: left;

                > div {
                    font-weight: 500;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                > small {
                    font-size: .75rem;
                }
            }

            &-checkout-btn {
                margin-left: 20px;
            }
        }
    }
</style>

<script>
  import Cart from '../components/Cart.vue';
  import MobileCart from '../components/MobileCart.vue';
  import Breadcrumbs from '../components/Breadcrumbs.vue';
  import PoweredBy from '../components/PoweredBy.vue';

  import cart from 'src/mixins/cartPage';

  export default {
    mixins: [cart],
    components: {
      Cart,
      MobileCart,
      Breadcrumbs,
      PoweredBy,
    },
  };
</script>

